import React from 'react';
import { IconProps } from './types';

const NaviTabIcon: React.FC<IconProps> = props => {
  const {
    height = '12',
    width = '12',
    fillColor = 'var(--grayscale-3)',
    onClick = () => {}
  } = props;
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.73471 4.37273C5.49121 4.13747 5.16707 4.00659 4.8304 4.00659H0V11.9999H2.67769V6.59091H5.35537V11.0984C5.35537 11.5962 5.75507 11.9999 6.24793 11.9999H8.03306V7.15633C8.03306 6.79533 7.88704 6.44975 7.62827 6.20026L5.73471 4.37273Z"
        fill="#22D081"
      />
      <path d="M5.45508 0V2.58432H9.44186V6.61105H12.0005V0H5.45508Z" fill="#22D081" />
    </svg>
  );
};
export default NaviTabIcon;
